import { ROOT } from "../config";

export const SUBMIT_CLIENT_INFO_REACT_API_PUBLIC = () => {
  return `${ROOT}/react-api/v3/activation/submit`;
};

export const GET_CLIENT_ACTIVATION_API = () => {
  return `${ROOT}/api/public/client/get-client-activation`;
};
